import {
  ArticleNewsIcon,
  CertificationIcon,
  GroupIcon,
  // LevelIcon,
} from '@pmi/dsm-react/dist/components/icons/fa/16';
import FilledIcon from '@pmi/dsm-react/dist/components/icons/16/bookmark/FilledIcon';
import { CategoryType } from '../CategoryLabel/models';
import styles from './selectAgreement.module.scss';

interface WizardCategoryLabelProps {
  type: CategoryType;
}

export default function WizardCategoryLabel({
  type,
}: WizardCategoryLabelProps) {
  switch (type) {
    case 'Certification':
      return (
        <div className="d-flex gap-1">
          <CertificationIcon className={styles.certificationIcon} />
          <div className={`${styles.certificationText} ${styles.typography12}`}>
            Certifications
          </div>
        </div>
      );
    case 'Digital Product':
      return (
        <div className="d-flex gap-1">
          <ArticleNewsIcon className={styles.digitalProductsIcon} />
          <div
            className={`${styles.digitalProductsText} ${styles.typography12}`}
          >
            Digital Products
          </div>
        </div>
      );
    case 'eLearning':
      return (
        <div className="d-flex gap-1">
          <FilledIcon className={styles.elearningIcon} />
          <div className={`${styles.elearningText} ${styles.typography12}`}>
            Online Courses
          </div>
        </div>
      );
    case 'Membership':
      return (
        <div className="d-flex gap-1">
          <GroupIcon className={styles.membershipIcon} />
          <div className={`${styles.membershipText}  ${styles.typography12}`}>
            {type}
          </div>
        </div>
      );
    case 'Chapter Membership':
    case 'Bundle':
      return null;
    default:
      return null;
  }
}
